import qs from 'qs';
import config from '../config';
import CreativeChallengeDataManager from './creative-challenge-data-manager';
import CreativeChallengeBrowser from './creative-challenge-browser';
import CreativeChallengeBrowserNav from './creative-challenge-browser-nav';
import CreativeChallengeMap from './creative-challenge-map';

export default function initCreativeChallenge(id, dataFile, galleries, options) {
  const dataManager = new CreativeChallengeDataManager(id, dataFile, galleries, options);

  $(`[data-component=creative-challenge-browser][data-creative-challenge-id=${id}]`)
    .each(async (i, element) => {
      const browser = new CreativeChallengeBrowser(dataManager, options);
      await browser.init();
      $(element).replaceWith(browser.$element);
    });

  $(`[data-component=creative-challenge-nav][data-creative-challenge-id=${id}]`)
    .each((i, element) => {
      const nav = new CreativeChallengeBrowserNav(element);
      nav.init();
    });

  $(`[data-component=creative-challenge-map][data-creative-challenge-id=${id}]`)
    .each(async (i, element) => {
      const qsArgs = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      const mapboxAPIKey = qsArgs?.mapBoxAPIKey ?? config.mapboxAPIKey;
      const map = new CreativeChallengeMap(dataManager, mapboxAPIKey);
      $(element).replaceWith(map.$element);
      await map.init();
    });
}
